import { useCallback, useEffect, useState } from 'react';
import { getCommissionSummary, getCommissions } from '../api/commissions.api';
import type { CommissionSummary, CommissionsPage } from '../types/commission.types';

export function useCommissions(page: number, params: { representativeId: string; mobile: string; tenantId: string }) {
  const [data, setData] = useState<CommissionsPage>({ commissions: [], meta: { page, limit: 20, total: 0 } });
  const [summary, setSummary] = useState<CommissionSummary | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(() => {
    setLoading(true);
    setError(null);
    return Promise.all([getCommissions(page, 20, params), getCommissionSummary(params)])
      .then(([commissions, nextSummary]) => { setData(commissions); setSummary(nextSummary); })
      .catch(() => setError('خطا در دریافت اطلاعات کمیسیون‌ها'))
      .finally(() => setLoading(false));
  }, [page, params.representativeId, params.mobile, params.tenantId]);

  useEffect(() => { load(); }, [load]);
  return { ...data, summary, loading, error, refetch: load };
}
